export default __webpack_public_path__ + "static/thumbnail-8e13311c337dfa62902c29c73ca4b171.png";